const FlowActions = {
  LOADED: "flow/loaded",
  UPDATED: "flow/updated",
  LIST_LOADED: "flows/loaded",
  LIST_CHANGED: "flows/changed",
};

export default FlowActions;
